import { Pencil } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Compact static amber pill rendered next to the centred page title in
 * TopHeader while the user is on the PO edit screen. No animation — the
 * earlier glowing variant clipped against TopHeader's bounds and read as
 * noisy. The static ring + saturated amber is enough to signal state.
 * Translated surfaces (the manual order edit page) pass their own `label`.
 */
export function EditingPill({ className, label = "Editing" }: { className?: string; label?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full leading-none",
        "bg-amber-100 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-amber-900",
        "ring-1 ring-amber-300/80",
        className,
      )}
    >
      <Pencil className="h-3 w-3" aria-hidden="true" />
      {label}
    </span>
  );
}
